import Box from '@repo/ui/box'
import { BuildingThreeIcon } from '@repo/ui/icons'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { getCenterEvent } from '../../../../api/center-event/get-center-event'
import LoadingScreen from '../../../../components/elements/loading/loading-screen'
import UserNavBar from '../../../../components/elements/nav-bar'
import NotFoundPage from '../../../common/not-found'
import CenterEventData from './center-event-data'

const CenterEventDetailsPage = () => {
  const { eventId } = useParams<{ id: string; eventId: string }>()

  const { data: centerEvent, isPending } = useQuery({
    queryKey: ['center-events', eventId],
    queryFn: () => {
      if (!eventId || isNaN(Number(eventId))) return
      return getCenterEvent(Number(eventId))
    }
  })
  const center = centerEvent?.center

  if (isPending) return <LoadingScreen />
  if (!center || !centerEvent) return <NotFoundPage />

  return (
    <div>
      <UserNavBar title={center?.name} icon={BuildingThreeIcon} />
      <div className="h-4" />
      <Box className="flex flex-col gap-4">
        <CenterEventData centerEvent={centerEvent} />
      </Box>
    </div>
  )
}

export default CenterEventDetailsPage
